import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import TnC from '../views/TnC.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/terms-and-conditions',
    name: 'TnC',
    component: TnC
  },
]

const router = createRouter({
  history: createWebHistory("oralb-moneyback"),
  routes
})

export default router
